import * as Panel2 from '@wandb/weave/components/Panel2/panel';
import * as React from 'react';
import {useMemo} from 'react';

import {maybePluralize} from '../../util/uihelpers';
import * as urls from '../../util/urls';
import {RegistryName} from '../../util/urls';
import {Pagination, sliceArray} from '../Pagination';
import {CardCollectionType} from '../Registries/common/types';
import {ArtifactCollectionCard} from '../Registries/Registry/ArtifactCollectionCard';
import {InstrumentedLoader} from '../utility/InstrumentedLoader';
import {useFilterCollectionNodesBasedOnSearchString} from './hooks';
import {NoModelsFound} from './NoModelsFound';
import * as S from './PanelArtifactCollectionCards.styles';

export type ConfigType = {};
const inputType = {type: 'list' as const, objectType: 'artifact' as const};
const PAGE_SIZE = 10;

export const PanelArtifactCollectionCards = ({
  input,
  searchFilter,
  selectionPath,
  registryName,
  showEntity,
  page,
  setPage,
}: Panel2.PanelProps<typeof inputType, ConfigType> & {
  searchFilter?: string;
  selectionPath?: urls.SelectionPathType;
  registryName: RegistryName;
  showEntity?: boolean;
  page: number;
  setPage: (val: number) => void;
}) => {
  const filteredCollections = useFilterCollectionNodesBasedOnSearchString(
    input,
    searchFilter
  );

  const currentPaginatedCollections = useMemo(() => {
    return sliceArray(filteredCollections.result ?? [], page, PAGE_SIZE);
  }, [filteredCollections, page]);

  if (filteredCollections.loading) {
    return <InstrumentedLoader name="panel-artifact-collection-loader" />;
  }

  if (filteredCollections.result.length === 0) {
    return <NoModelsFound />;
  }

  return (
    <>
      <S.CollectionsSummary>
        {maybePluralize(
          filteredCollections.result.length,
          `registered ${registryName}`
        )}
      </S.CollectionsSummary>
      {currentPaginatedCollections.map(filteredCollection => {
        return (
          <ArtifactCollectionCard
            key={filteredCollection?.collectionId}
            registryName={registryName}
            collectionInfo={{
              collection: filteredCollection,
              type: CardCollectionType.DEFAULT,
            }}
            showEntity={showEntity}
            legacySearchFilter={searchFilter}
          />
        );
      })}
      {currentPaginatedCollections.length > 0 && (
        <S.PaginationPanel>
          <Pagination
            itemCount={filteredCollections.result.length}
            page={page}
            perPage={PAGE_SIZE}
            onPageChange={pageVal => {
              setPage(pageVal);
            }}
          />
        </S.PaginationPanel>
      )}
    </>
  );
};
